import type { ActionHandler } from './types';

export const saveToStorageHandler: ActionHandler = {
  type: 'save_to_storage',
  execute(ctx) {
    const storageKey = ctx.config.key ? String(ctx.config.key) : ctx.action.label;
    const storageValue = ctx.config.value != null ? String(ctx.config.value) : 'true';
    const storageTarget = String(ctx.config.storage ?? 'local');
    if (!storageKey) return;
    if (storageTarget === 'session') {
      sessionStorage.setItem(storageKey, storageValue);
    } else {
      localStorage.setItem(storageKey, storageValue);
    }
  },
};
